<template>
  <div>
    <el-select :value="value" value-key="id" :placeholder="$t('card.package_duration')" :size="size" @input="change($event)" :clearable="true">
      <el-option v-for="item in optionsReader()" :key="item.id" :label="item.effect + ' ----- ' + (item.enabled === 1?'生效中': '未生效')" :value="item" />
    </el-select>
    <el-button v-if="config && config.update" @click="handleUpdate" >{{ $t('table.update') }}</el-button>
  </div>
</template>

<script>

import { fetchCycleList } from '../api/package'
export default {
  data () {
    return {
      emptyValue: { id: 0 },
      options: [],
      configOptions: null,
      optionsReader: () => { if (this.config) { return this.configOptions } return this.options }
    }
  },
  created () {
    this.list()
  },
  mounted () {
  },
  props: ['iccid', 'value', 'config', 'size', 'showAllTip', 'showAllTipLabel'],
  methods: {
    change: function (val) {
      this.$emit('input', val)
    },
    list: function () {
      this.options = []
      this.configOptions = null
      if (this.iccid && (this.iccid.length === 20 || this.iccid.length === 19)) {
        fetchCycleList({iccid: this.iccid}).then((res) => {
          this.options = res.data.map((item) => { item.id = parseInt(item.id); return item })
          this.configOptions = this.config ? this.options.filter((item) => { return item.id === parseInt(this.config.selected) }) : this.options
        })
      }
    }
  },
  watch: {
    iccid: function (val, old) {
      this.list()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/CycleSelect.vue